module.exports = __webpack_public_path__ + "static/img/wizdom-wonders.62eae24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wizdom-wonders.jpg
// module id = kJ2k
// module chunks = 0